import { motion } from 'framer-motion';
import ScrollReveal from '@/components/base/ScrollReveal';

const audiences = [
  { icon: 'ri-briefcase-line', label: 'Agencias' },
  { icon: 'ri-user-line', label: 'Freelancers' },
  { icon: 'ri-team-line', label: 'Community Managers' },
  { icon: 'ri-bar-chart-line', label: 'Traffickers' },
  { icon: 'ri-lightbulb-line', label: 'Emprendedores' },
  { icon: 'ri-building-line', label: 'Empresas' },
  { icon: 'ri-camera-line', label: 'Creadores de Contenido' },
];

export default function PerfectFor() {
  return (
    <section className="relative bg-white py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-4">
              Audiencia
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Perfecto para
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
              Diseñado para cualquier persona que cree anuncios, gestione redes o venda online.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-5">
          {audiences.map((a, i) => (
            <ScrollReveal key={a.label} delay={i * 0.06}>
              <motion.div
                whileHover={{ y: -4, scale: 1.02, transition: { duration: 0.2 } }}
                className="flex flex-col items-center text-center p-6 rounded-2xl bg-foreground-50 border border-transparent hover:border-foreground-200 hover:bg-white hover:shadow-[0_8px_24px_rgba(0,0,0,0.04)] transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-white border border-foreground-100 flex items-center justify-center mb-3">
                  <i className={`${a.icon} text-primary-500 text-xl`} />
                </div>
                <span className="text-sm font-semibold text-foreground-800">{a.label}</span>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}